function Table(options){
	this.className		= "Table";
	this.templateModel	= Aviator.get('baseController').viewModel;
	this.templates		= this.templateModel.templates;
	if(options) this.setup.apply(this, arguments);
};
Table.inheritsFrom( EventTarget );
Table.prototype.setup = function(options){
	if(!options) options = {};
	this.options = options;

	this.$holder			= options.$holder;
	this.template			= options.template ? options.template : "objects/tables/base";
	this.headings 			= options.headings;
	this.data 				= options.data;
	this.footings 			= options.footings;
	this.title				= options.title;
	this.noDataMessage		= options.noDataMessage;
	this.filteredOutMessage = options.filteredOutMessage ? options.filteredOutMessage : "No matching rows found.";
	this.insertType			= options.insertType ? options.insertType : "append";
	this.useSortByDefault	= options.sort;
	this.defaultSort		= options.defaultSort;
	this.activeFilters		= {};
	this.collapseOrder		= options.collapseOrder ? options.collapseOrder : false;
	this.responsive			= typeof options.responsive == "boolean" ? options.responsive : true;
	this.state				= {
		columns: {
			total: 		this.headings.length,
			visible: 	this.headings.length,
			hidden:		0
		},
		measured: 		false,
		width: 			{},
		currentColumn:	false
	};
	this.spacing			= {
		column:		15,		// how much extra space to allow for each column when making show/hide judgements
		selector:	25		// how much extra space to allow for the column selector
	}

	if(!this.defaultSort){
		if(typeof(this.useSortByDefault) == "string"){
			this.defaultSort = [this.useSortByDefault,"desc"]
			this.useSortByDefault = true;
		}
	}

	/*
	 * Table: Header
	 */
	for (var i = 0; i < this.headings.length; i++) {
		var heading = this.headings[i];
		if(heading.headingTemplate){

			// old
			// heading.content = Mustache.render(Aviator.get("mainController").templates[heading.headingTemplate].html,heading);

			// pick up content, possibly inline HTML
			var html = heading.headingTemplate;

			// see if it's actually a known template
			var templateFile = this.templates[heading.headingTemplate];
			if(templateFile) html = templateFile.html;

			//var dataSummary = Igloo.merge({fullData:data, formatted: f},Igloo.clone(d,false));
			var dataSummary = heading;

			var handlebar 		= Handlebars.compile(html);
			heading.html 		= true;
			heading.content 	= handlebar(dataSummary);

		}else{
			heading.simple = true;
		}
		if(this.useSortByDefault && !heading.sort && heading.sort !== false) heading.sort = true;
		if(!heading.lookup) heading.lookup = heading.name;

		//if(!heading.key && heading.sort && heading.sort !== true) heading.key = heading.sort;
	}

	/*
	 * Table: Footer with headings & rows
	 */
	for (var i = 0; i < this.footings.length; i++) {
		var footing = this.footings[i];

		for (var x = 0; x < footing.headings.length; x++) {
			var heading = footing.headings[x];
			//console.log(cell);

			if(heading.footingTemplate){

				// pick up content, possibly inline HTML
				var html = heading.footingTemplate;

				// see if it's actually a known template
				var templateFile = this.templates[heading.footingTemplate];
				if(templateFile) html = templateFile.html;

				//var dataSummary = Igloo.merge({fullData:data, formatted: f},Igloo.clone(d,false));
				var dataSummary 	= heading;

				var handlebar 		= Handlebars.compile(html);
				heading.html 		= true;
				heading.content 	= handlebar(dataSummary);

			}else{
				heading.simple = true;
			}
			if(!heading.lookup) heading.lookup = heading.name;
		}

		footing.rows = this.processRows(footing.data, footing.headings);
	}

	/*
	 * Table: Process cells
	 */
	this.rows = this.processRows(this.data, this.headings);

	// ensure table is updated for correct stylings
	this.markHolderAsEmpty(!this.rows.length);

	//this.template = options.template ? options.template : "objects/tables/base";

	// Handlebars
	var template = this.templateModel.getTemplateDetails(this.template);
	var compiled = Handlebars.compile(template.html);
	var html = compiled({
		title:				this.title,
		headings: 			this.headings,
		rows:				this.rows,
		footings: 			this.footings,
		noDataMessage: 		this.noDataMessage
	});

	// Mustache
	/*
	var html = Mustache.render(template.html,{
		title:				this.title,
		headings: 			this.headings,
		rows:				this.rows,
		noDataMessage: 		this.noDataMessage
	});
	*/

	//Save the elements
	if(this.insertType == "append"){
		this.$table = this.$holder.append("<div class='xtable js-table-identifer'>"+html+"</div>").find(".js-table-identifer:last").removeClass("js-table-identifer");
	}else{
		this.$holder.html(html);
		this.$table = this.$holder;
	}

	// per-heading stuff - sort functionality, setting default visibility
	for (var i = 0; i < this.headings.length; i++) {
		var heading 		= this.headings[i];
		heading.$heading 	= this.$table.find("[data-heading-col='"+heading.name+"']");
		heading.$sort 		= heading.$heading.find(".js-sort-vertical-arrows");
		heading.visible		= true;

		// collapsible
			// - if no column collapse order specified, any column other than the first is collapsible
			// - otherwise, it has to be in the collapse order list or the right-most column from what is left
		heading.collapsible = this.collapseOrder ? this.collapseOrder.includes(heading.name) || i == (this.headings.length-1) : i > 0;

		if(heading.sort){

			// ok this isn't right - was mostly working but had problems sometimes with templates.
			// then I discovered "lookup" which I suppose was what I was intending?
			// but setting lookup (in order to help sort) caused complete failure to build table
			// so... for launch, sadly some columns will simply not sort properly until fixed next week
			if (!heading.sortUsing) heading.sortUsing = heading.name;

			heading.$sort.show();
			heading.$sortUp 	= heading.$sort.find(".js-sort-up");
			heading.$sortDown 	= heading.$sort.find(".js-sort-down");

			heading.$heading.on("click",Igloo.$d(this,function($this,sortUsing,defaultSortDir,e){
				this.sortToggle(sortUsing,defaultSortDir);
			},heading.sortUsing,heading.defaultSortDir));
			heading.$sortUp.on("click",Igloo.$d(this,function($this,sortUsing,defaultSortDir,e){
				e.stopPropagation();
				this.sortToggle(sortUsing,defaultSortDir);
			},heading.sortUsing,heading.defaultSortDir));
			heading.$sortDown.on("click",Igloo.$d(this,function($this,sortUsing,defaultSortDir,e){
				e.stopPropagation();
				this.sortToggle(sortUsing,defaultSortDir);
			},heading.sortUsing,heading.defaultSortDir));

		}else{
			heading.$sort.hide();
		}
	}

	for (var i = 0; i < this.rows.length; i++) {
		var row = this.rows[i];
		row.$row = this.$table.find(".js-table-body [data-row='"+i+"']");
	}

	this.$rowWrapper = this.rows.length ? this.rows[0].$row.parent() : false; //Saves us from having to label it.

	//ToolTip.build(this.$table,{delay:250});

	setTimeout(Igloo.delegate(this,function() {
		this.fire("rendered", {table:this, $table: this.$table});
	}),0);

	//Setup search
	this.$searchInput = this.$table.find("input[name='search']");
	if(this.options.searchInput === false) this.$searchInput.hide();
	else if(this.$searchInput.size()){
		if(!("ActiveXObject" in window)) this.$searchInput.focus(); //Not IE.
		this.$searchInput.on("input propertychange",Igloo.delegate(this,this.searchUpdate));
		this.$searchInput.on("keydown",Igloo.delegate(this,function(e){
			if(e.which == 27){
				this.$searchInput.val("");
				this.searchUpdate();
			}
		}))
	}

	// set up column selector
	this.$columnSelector = this.$table.find(".js-column-selector");
	this.$columnSelector.find(".js-column-selector-trigger").on("click",(e) => e.preventDefault());

	this.$columnChoices = this.$columnSelector.find(".js-column-choice");
	$.each(this.$columnChoices, Igloo.$d(this,function($this,i){
		var columnName = $this.attr("data-column-name");

		var findHeading = Igloo.searchArray(this.headings,"name",columnName);
		if (findHeading){

			if (findHeading.collapsible){
				$this.on("click",Igloo.$d(this,function($this,e){
					e.preventDefault();
					$this.addClass("checked");
					$this.siblings().removeClass("checked");
					this.selectColumn(columnName);
				}))

				// save it on the heading object too, why not?
				findHeading.$selector = $this;
			} else {
				$this.remove();
			}
		} else {
			$this.remove();
		}

	}))

	// default sort
	if(this.defaultSort) this.sort(this.defaultSort[0],this.defaultSort[1],{events:false});

	// on resize
	this.resizeDelegate = jstage.addListener("resize",Igloo.delegate(this, this.onResize));
	this.onResize(); // do one to begin

}
Table.prototype.processRows = function(rowData, headings){
	if(!headings) return rowData;

	//var dateFormat = Aviator.get("settings").get("d");
	var dateFormat = "YYYY-MM-DD";

	var search = [];
	var rows = [];
	for (var j = 0; j < rowData.length; j++) {
		var data = rowData[j];
		//console.log(rowData, headings)

		var row = { index: j, cols: [], classString: data.classString, visible: true, search: "", data: data };

		if (this.options.rowReference) row.rowReference = data[this.options.rowReference];

		var dataSummary = () => Igloo.merge({fullData:data, formatted: f, value: d},Igloo.clone(d,false));

		for (var i = 0; i < headings.length; i++) {
			var h = headings[i];

			var col = { name: h.name };

			var d = h.data == "all" ? data : data[h.lookup];
			var k = d;

			if(h.key) k = d ? d[h.key] : undefined;

			var f = k;
			if(h.type == "date"){
				f = k ? moment(k).format(dateFormat) : "-";
				if(typeof(k) == "string") k = moment(k).valueOf();
			}
			if(h.type == "number"){
				f = k || k === 0 ? numeral(k).format('0,0') : "-";
			}
			if(h.formatted){
				if(typeof(h.formatted) == "function"){
					f = h.formatted(dataSummary());

				}else{
					f = data[h.formatted];
				}
			}
			if(h.display){
				f = typeof(h.display) == "function" ? h.display(data[h.lookup],data) : data[h.display];
			}

			// Attempt to load in partial file automatically from base template location.
			var templatePartialFile = this.templates.find(t => t.name === `${this.template}-${h.name}`);
			if(templatePartialFile){
				h.template = h.template ? h.template : templatePartialFile.name;
			}

			if(h.template){

				// pick up content, possibly inline HTML
				var html = h.template;

				// see if it's actually a known template
				var templateFile = this.templates[h.template];
				if(!templateFile) templateFile = this.templates.find(t => t.name == h.template);
				if(templateFile) html = templateFile.html;

				// var dataSummary = Igloo.merge({fullData:data, formatted: f, value: d},Igloo.clone(d,false));

				var handlebar 	= Handlebars.compile(html);
				col.html 		= true;
				col.content 	= handlebar(dataSummary());

			} else {

				if(h.html === true){
					col.html = true;
				}else if(h.html == "simple"){
					col.simpleHtml 	= true;
				}else{
					col.simple 	= true;
				}

				col.content = f;
			}

			col.heading = h.title ? h.title : h.content;

			col.data 	= k;
			col.sortValue = typeof(k) == "object" ? k[h.lookup] : k;



			if(typeof(col.data) == "string") col.data = col.data.toLowerCase();
			row.cols.push(col);

			if(h.search){
				var s = [];
				if(h.search === true){
					// when search is just boolean true then the searchable data is the same key as the column name
					if(data[h.lookup]) s.push(data[h.lookup]);
				}else{
					// use a specific key, or array of keys, to get the searchable data
					if(typeof(h.search) !== "object") h.search = [h.search];
					for (var k = 0; k < h.search.length; k++) {
						// not every row might have the data or that data have the key so add a check
						if(d && d[h.search[k]]) s.push(d[h.search[k]]);
					}
				}
				for (var k = 0; k < s.length; k++) {
					if(!s[k]) continue;
					if(typeof(s[k]) !== "string") s[k] = ""+s[k];
					row.search += (row.search?" ":"")+s[k].toLowerCase();
				}
			}
		}
		// console.log(row);
		rows.push(row);

	}

	return rows;
}

Table.prototype.getRows = function() {
	return this.rows;
}
Table.prototype.getRowById = function(rowId) {
	return Igloo.searchArrayWeak(this.rows,"index",rowId);
}
Table.prototype.getRowByMeta = function(meta,multiple) {

	var metaCount = 0;
	for (var i in meta)	metaCount++;

	var results = [];
	for (var i = 0; i < this.rows.length; i++) {
		var row = this.rows[i];
		var found = 0;
		for (var j in meta) {
			if(row.data[j] == meta[j]) found++;
		}
		if(found == metaCount) results.push(row);
	}

	return multiple ? results : (results[0]?results[0]:false);

}
Table.prototype.getWrapper = function() {
	return this.$table;
}
Table.prototype.sort = function(name, direction, options) {
	if(!options) options = {};

	var isClear = false;
	if((this.sortColumn == name && this.sortDirection == direction) || name === false || direction === false){
		isClear = true;
	}

	var simpleSortData = [];
	if(isClear){
		this.sortColumn 	= false;
		this.sortDirection 	= false;

		for (var i = 0; i < this.rows.length; i++) {
			simpleSortData.push({index:i});
		}

	}else{
		this.sortColumn 	= name;
		this.sortDirection 	= direction;

		var searchColIndex 		= Igloo.isIn(this.headings,"name",this.sortColumn);

		for (var i = 0; i < this.rows.length; i++) {
			var row = this.rows[i];
			var d = row.cols[searchColIndex].sortValue;
			simpleSortData.push({index:i,data:d});
		}

		simpleSortData.sort(function(a,b){

			var aType = typeof(a.data);
			var bType = typeof(b.data);

			// identify comparison types when both match
			var matchingDataType = aType == bType ? aType : false;

			var reverse = direction === "asc" ? 1 : -1;

			if(a.data == b.data) 					return 0;
			else if(typeof(b.data) == "undefined")	return -1;
			else if(typeof(a.data) == "undefined")	return 1;
			else if(matchingDataType == "number")	return a.data > b.data ? 1 * reverse : -1 * reverse;
			else if(matchingDataType == "boolean")	return a.data ? 1 * reverse : -1 * reverse;
			else return a.data.localeCompare(b.data, 'en', {'sensitivity': 'base'}) * reverse;
		});

	}

	this.order = simpleSortData;

	this.renderSort();
	if(options.events !== false){
		this.fire("sorted",{table:this,column:name,direction:direction,cleared:isClear});
	}

}
Table.prototype.sortToggle = function(name,defaultSortDir) {
	var direction = false;

	if (name !== this.sortColumn){
		// not currently sorting on this column
		direction = defaultSortDir ? defaultSortDir : "asc"; // if this column has a default, use it, otherwise assume ascending
	} else {
		// currently on this column, invert current direction
		direction = this.sortDirection == "desc" ? "asc" : "desc";
	}

	return this.sort(name,direction);
}
Table.prototype.renderSort = function(e) {

	for (var i = 0; i < this.headings.length; i++) {
		var heading = this.headings[i];
		if(!heading.sort) continue;
		if(heading.name == this.sortColumn){
			heading.$sort.addClass("sorting-active");
			heading.$sortUp.toggleClass("active",this.sortDirection == "asc");
			heading.$sortDown.toggleClass("active",this.sortDirection == "desc");
		}else{
			heading.$sort.removeClass("sorting-active");
			heading.$sortUp.removeClass("active");
			heading.$sortDown.removeClass("active");
		}
	}

	//Now reorder
	for (var i = 0; i < this.order.length; i++) {
		var order = this.order[i];
		var index = order.index;

		var row = Igloo.searchArray(this.rows,"index",index);
		this.$rowWrapper.append(row.$row);
	}

}
Table.prototype.renderFilter = function(e) {

	// don't even try and filter when we don't have any rows
	if (!this.rows.length) return false;

	for (var i = 0; i < this.rows.length; i++) {
		var row = this.rows[i];
		row.$row.toggle(row.visible);
	}

	if (this.rows.every(row => !row.visible)){
		// no rows are visible now
		this.markHolderAsEmpty();

		// if we have a message to display, do so
		if (this.filteredOutMessage){
			// have we added it before? if not then make it
			if (!this.$filteredOut) {
				var foRow = $("<td>").attr("colspan",this.headings.length).html("<div class='cell'><div class='main'>"+this.filteredOutMessage+"</div></div>");
				this.$filteredOut = $("<tr>").addClass("no-results filtered-out").append(foRow);
				this.$holder.find("tbody").append(this.$filteredOut);
			}
			// show it
			this.$filteredOut.show();
		}

	} else {
		this.markHolderAsEmpty(false);
		// if we were previously showing the filtered out message, hide it
		if (this.$filteredOut) this.$filteredOut.hide();
	}

	// in case content changes have affected column widths
	this.measureColumns(true);
}
Table.prototype.markHolderAsEmpty = function(hide){

	if (typeof hide != "boolean") hide = true;

	this.$holder.toggleClass("no-rows",hide);
}
Table.prototype.searchUpdate = function() {
	var q = this.$searchInput.val();
	this.addFilter("search",q);
}
Table.prototype.addFilter = function(name,value) {
	if (!name) return false;

	if (name == "search" && !!value === false){
		this.removeFilter("search");
	} else {
		this.activeFilters[name] = value;
		this.applyFilters();
	}
}
Table.prototype.removeFilter = function(name){
	if (!name) return false;

	if (this.activeFilters[name]){
		delete this.activeFilters[name];
		this.applyFilters();
	}
}
Table.prototype.applyFilters = function() {

	var activeFilters 	= Igloo.clone(this.activeFilters);
	var filters 		= Object.keys(activeFilters);
	var matches 		= [];

	// check each row
	this.rows.forEach((r,i) => {

		// check each filter on this row
		filters.forEach(key => {
			var value = this.activeFilters[key];

			if (key == "search"){
				// search functionality is obviously a bit more specific
				var words = value.toLowerCase().split(" ");

				// TODO - currently search operates with OR logic - should probably be AND
				var text = r.search;
				var found = false;
				words.forEach(w => {
					if (found) return; // only count search as matching once
					var re = new RegExp(w);
					var x = text.match(re);
					if(x){
						if (!matches.hasOwnProperty(i)) matches[i] = 0;
						matches[i]++;
						found = true;
					}
				})

			} else {
				// if not search then we're looking at specific data keys
				if (r.data[key] === value) {
					if (!matches.hasOwnProperty(i)) matches[i] = 0;
					matches[i]++;
				}
			}
		})

	})

	// which rows matched all filters?
	this.rows.forEach((r,i) => {
		r.visible = filters.length == 0 || (matches.hasOwnProperty(i) && matches[i] == filters.length)
	});

	// note that we are passing different data here now - but the only listener for "filtered" I could find is on old teams controller
	this.updateFilters({filters:activeFilters, matches: matches.length});

}
Table.prototype.updateFilters = function( eventData = {}) {
	this.renderFilter();
	this.fire("filtered",Object.assign({table:this},eventData));
}
Table.prototype.measureHolder = function(){
	this.state.width.holder = this.$holder.width();
}
Table.prototype.measureTable = function(){
	this.state.width.total 		= this.headings.reduce((a,b) => a + b.columnWidth, 0);
	this.state.width.visible 	= this.headings.reduce((a,b) => a + (b.visible ? b.columnWidth : 0), 0);
}
Table.prototype.updateTableStatus = function(){
	//this.state.full 			= this.state.width.total == this.state.width.visible;
	this.state.full				= this.state.columns.visible == this.state.columns.total;
}
Table.prototype.measureColumns = function(force){

	// shouldn't be doing this if not responsive?
	if (!this.responsive){
		console.log("hiding");
		this.$columnSelector.hide();
		return false;
	}

	// only need to measure once ideally - but because content can change widths we need a force option to remeasure
	if (force || !this.state.measured){

		// set table css for better measurements
		this.$table.children("table").css({
			whiteSpace: "nowrap",
			width:		"auto"
		});

		this.headings.forEach(heading => {

			var columnWidth = false;

			// forced width
			if (heading.width) columnWidth = heading.width;

			// if forced width not supplied, measure
			if (!columnWidth) columnWidth = heading.$heading.width();

			// minimum width specified?
			var minWidthType = typeof heading.minWidth;
			if (minWidthType == "number"){
				columnWidth = Math.max(columnWidth,heading.minWidth);
			} else if (minWidthType == "function"){
				columnWidth = heading.minWidth(columnWidth,heading);
			}

			// store - only adding extra column width if the measurement is valid (if 0 then columnWidth will be falsey)
			heading.columnWidth = columnWidth ? columnWidth + this.spacing.column : 0;
		})

		// reset table
		this.$table.children("table").css({
			whiteSpace: "",
			width:		""
		});

		// calculate useful total widths
		this.measureTable();

		// mark measurements as done, so long as nothing came up 0, then we're in trouble
		this.state.measured = !this.headings.some(h => !h.columnWidth);
		//console.log("valid measurement?", this.state.measured, this.headings.map(h => h.columnWidth));
	}

	//console.log("total:",this.state.width.total,"visible:",this.state.width.visible,"holder:",this.state.width.holder);

	// don't try and do anything if we don't have valid measurements
	if (this.state.measured){

		var actionFunction = false;

		if (this.state.full){

			// we're currently showing the whole table, only possible thing we might need to do is show less
			// if table is larger than holder, we need to show less
			if (this.state.width.total > this.state.width.holder) actionFunction = "contractTable";

		} else {

			// we're not showing the whole table at the moment, we could need to grow or shrink

			if (this.state.width.total < this.state.width.holder){
				// if whole table isn't as big as the holder, we have the room to show it all
				actionFunction = "showFullTable";
			} else if (this.state.width.visible > this.state.width.holder){
				// if what's currently visible is bigger than the holder, we need to show less
				actionFunction = "contractTable";
			} else {
				// if what's currently visible is smaller than the holder, we *might* need to show more
				actionFunction = "extendTable";
			}
		}

		if (actionFunction && typeof this[actionFunction] == "function"){

			// run the function
			this[actionFunction]();

			// required updates
			this.updateTableStatus();
			this.checkColumnSelector();

		}
	}

}
Table.prototype.showFullTable = function(){
	// turn all columns on
	this.headings.filter(h => !h.visible).forEach(h => this.toggleColumn(h,true));
}
Table.prototype.contractTable = function(){
	// what's currently visible is too big - we need to remove column(s)
	while (this.state.width.visible > this.state.width.holder){
		if (this.collapseOrder){
			var columnToHide = false;
			this.collapseOrder.forEach(c => {
				if (columnToHide) return;
				var findHeading = Igloo.searchArray(this.headings,"name",c);
				if (findHeading && findHeading.visible) columnToHide = findHeading;
			})
		} else {
			// no priority specifed, remove the right-most visible column
			var columnToHide = this.headings[this.state.columns.visible-1];
		}

		if (columnToHide){
			//console.log("hide column",columnToHide);
			this.toggleColumn(columnToHide,false);
		} else {
			// need to get out of the loop, if we can't hide a column then state.width.visible will never come down
			break;
		}
	}
}
Table.prototype.extendTable = function(){
	// there is some room and we have some columns that aren't showing
	while (this.state.width.visible < this.state.width.holder){

		// work out which column is next to be added
		if (this.collapseOrder){
			var columnToShow = false;
			var reversePriorities = Igloo.clone(this.collapseOrder).reverse(); // we want to add columns in the opposite order they were removed
			reversePriorities.forEach(c => {
				if (columnToShow) return;
				var findHeading = Igloo.searchArray(this.headings,"name",c);
				if (findHeading && !findHeading.visible) columnToShow = findHeading;
			})
		} else {
			// no priority specifed, see if we can show the next column (which should also be the first one !visible)
			var columnToShow = this.headings[this.state.columns.visible];
		}

		// see if we have enough room to show the next column
		var availableSpace = this.state.width.holder - this.state.width.visible;

		// unless the column we want to add is the final one, we also need to take into account extra space required to prevent overlapping the column selector
		if ((this.state.columns.total - this.state.columns.visible) > 1) availableSpace -= this.spacing.selector;

		if (columnToShow && columnToShow.columnWidth < availableSpace){
			//console.log("show column",columnToShow);
			this.toggleColumn(columnToShow,true);
		} else {
			// not enough room to show the next column, stop trying
			break;
		}
	}
}
Table.prototype.checkColumnSelector = function(){

	// are we showing all columns? if not we need to make sure our column selector is in operation
	if (!this.state.full) {
		var foundRightColumn = false;

		// uncheck all selectors
		this.$columnChoices.removeClass("checked");

		// loop through in reverse to find the right-most visible column
		for (var i = this.headings.length - 1; i >= 0; i--) {
			var column = this.headings[i];

			// identify right-most visible column which is checked in the selector
			if (!foundRightColumn && column.visible/* && column.collapsible*/){
				foundRightColumn = column;
				this.state.currentColumn = column.name;
				if (column.$selector) column.$selector.addClass("checked");
			}

			var onRight = foundRightColumn && foundRightColumn.name == column.name;

			// show/hide selectors based on column visibility
			if (column.$selector) column.$selector.toggle(!column.visible || onRight);
		}
	}

	// show/hide as required
	this.$columnSelector.toggle(!this.state.full);
}
Table.prototype.toggleColumn = function(heading,show,toggling){

	// if heading is only a name not an object, need to look it up
	if (typeof heading == "string"){
		heading = Igloo.searchArray(this.headings,"name",heading);
	}

	if (!heading) return false;
	if (typeof show != "boolean") show = !heading.visible;

	// show/hide cells in HTML
	this.$table.find('thead tr th[data-heading-col="'+heading.name+'"]').toggle(show);
	this.$table.find('tbody tr td[data-col="'+heading.name+'"]').toggle(show);

	// update heading visibility
	heading.visible = show;

	// we only want to change the selector's visibility if this is a resize-based toggling - not a content toggle via the selector
	/*if (heading.$selector && !toggling){
		console.log("show selector?",heading.name,!show);
		heading.$selector.toggle(!show);
	}*/

	// update count
	this.state.columns.visible += (show ? 1 : -1);

	// update visible width
	this.state.width.visible += (show ? heading.columnWidth : -heading.columnWidth);
	//console.log("visible column width is now",this.state.width.visible,"after "+(show?"adding":"subtracting"),heading.columnWidth);
}
Table.prototype.selectColumn = function(columnName){
	if (!columnName || columnName == this.state.currentColumn) return false;

	//console.log("toggling in column:",columnName);
	//console.log("toggling out column:",this.state.currentColumn);
	this.toggleColumn(this.state.currentColumn,false,true);
	this.toggleColumn(columnName,true,true);

	this.state.currentColumn = columnName;

	// check to see if the changed content made the table too wide (or allows for another column to be shown)
	this.measureColumns();
}
Table.prototype.onResize = function() {
	if (this.responsive){
		this.measureHolder();
		this.measureColumns();
	}
}
Table.prototype.refresh = function() {
	// function that can be called by the parent controller when page is rendered
	this.onResize();
}
Table.prototype.destroy = function() { //Todo
	this.$table.html("");
	if(this.insertType == "append") this.$table.remove();
	if(this.resizeDelegate) jstage.removeListener("resize",this.resizeDelegate);
}